import React, { useState, useEffect } from "react";
import axios from "axios";
import FacilityManifestsPerYearChart from "./FacilityManifestsPerYearChart";
import FacilityTonnagePerYearChart from "./FacilityTonnagePerYearChart";
import CAManifestGrid from "./CAManifestGrid";
import { Row, Col } from "react-bootstrap";

export default function ManifestSection(props) {
  const [isFetchingTonsCounts, setIsFetchingTonsCounts] = useState(false);
  const [camanifesttonscounts, setCamanifesttonscounts] = useState([]);

  useEffect(() => {
    setIsFetchingTonsCounts(true);
    //Get CA Manifest Counts and Tonnage by Year
    axios
      .get(
        `api/v1/hwts/search/facility/countandtonnagebysitetype?EpaId=${props.EPA_ID}`
      )
      .then((results) => {
        setCamanifesttonscounts(results.data);
        setIsFetchingTonsCounts(false);
      })
      .catch((error) => {
        setIsFetchingTonsCounts(false);
      });
  }, [props.EPA_ID]);

  var manifestsection = "";
  if (!isFetchingTonsCounts && camanifesttonscounts.length === 0) {
    manifestsection = (
      <div className="m-t-md text-center">
        No Manifest Data for this ID Number.
      </div>
    );
  } else if (isFetchingTonsCounts) {
    manifestsection = (
      <div className="" style={{ width: "4%", margin: "auto" }}>
        <div
          className="text-center loader"
          style={{
            width: "40px",
            height: "40px",
            border: "5px solid #ccc",
            borderTop: "5px solid #3498db",
          }}
        ></div>
      </div>
    );
  } else {
    manifestsection = (
      <div>
        <Row>
          <Col md="6" xs="12">
            <FacilityManifestsPerYearChart data={camanifesttonscounts} />
          </Col>
          <Col md="6" xs="12">
            <FacilityTonnagePerYearChart data={camanifesttonscounts} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col>
            <CAManifestGrid
              EPA_ID={props.EPA_ID}
              data={camanifesttonscounts}
              isFetching={isFetchingTonsCounts}
            />
          </Col>
        </Row>
      </div>
    );
  }

  return <div>{manifestsection}</div>;
}
